if (!customElements.get('accordion-list')) {
  customElements.define(
    'accordion-list',
    class AccordionList extends HTMLElement {
      connectedCallback() {
        this.items = [];
      }

      register(item) {
        this.items.push(item);

        if (this.items.length === 1 && this.hasAttribute('data-first-open')) {
          item.open();
        }
      }

      handleOpen(item) {
        if (!this.hasAttribute('data-single-open')) return;

        this.items.forEach((other) => {
          if (other !== item) other.close();
        });
      }
    }
  );
}
